import React from "react";

import DigisacIntegration from "./digisac";
import PipefyIntegration from "./pipefy";
import ReleaseAccessIntegration from "./releaseAccess";
import MonthlyReportIntegration from "./monthlyReport";

const Integrations = () => {
	return (
		<>
			<DigisacIntegration />
			<PipefyIntegration />
			<ReleaseAccessIntegration />
			<MonthlyReportIntegration />
		</>
	);
};
export default Integrations;
